import React from "react";

function ProspectsCorporateMember(props) {
  return (
    <div>
      <div className="grid gap-8 py-0 grid-cols-1">
        <div className="relative justify-center prospects p-4 pl-24 rounded-lg">
          <div className="flex flex-row items-center justify-between title">
            <div className="icon" onClick={props.redirectToProspect}>Prospects</div>
            <div className="number">{props.dashboardDetails.totalProspects}</div>
          </div>
          <div className="flex flex-row items-center justify-between" >
            <div>Submitted</div>
            <div className="underline cursor-pointer" onClick={() => props.redirectToProspect("isSubmitted", "true")}>{props.dashboardDetails.submitted}</div>
          </div>
          <div className="flex flex-row items-center justify-between">
            <div>Clarifications</div>
            <div className="underline cursor-pointer" onClick={() => props.redirectToProspect("isSentForClarification", "true")}>{props.dashboardDetails.clarifications}</div>
          </div>
          <div className="flex flex-row items-center justify-between" >
            <div>Pending Membership Committee</div>
            <div className="underline cursor-pointer" onClick={() => props.redirectToProspect("pendingMembershipCommittee", "true")}>{props.dashboardDetails.pendingMembershipCommittee}</div>
          </div>
          <div className="flex flex-row items-center justify-between" >
            <div>Membership Committee Approved</div>
            <div className="underline cursor-pointer" onClick={() => props.redirectToProspect("isMembershipCommitteeApproved", "true")}>{props.dashboardDetails.membershipCommitteeApproved}</div>
          </div>
          <div className="flex flex-row items-center justify-between">
            <div onClick={props.redirectToProspect}>Pending Management Committee</div>
            <div className="underline cursor-pointer" onClick={() => props.redirectToProspect("pendingManagementCommittee", "true")}>{props.dashboardDetails.pendingManagementCommittee}</div>
          </div>
          <div className="flex flex-row items-center justify-between">
            <div onClick={props.redirectToProspect}>Management Committee Approved</div>
            <div className="underline cursor-pointer" onClick={() => props.redirectToProspect("isManagementCommitteeApproved", "true")}>{props.dashboardDetails.managementCommitteeApproved}</div>
          </div>
          <div className="flex flex-row items-center justify-between">
            <div>Pending Payment</div>
            <div className="underline cursor-pointer" onClick={() => props.redirectToProspect("isPendingPayment", "true")}>{props.dashboardDetails.pendingPayment}</div>
          </div>
          <div className="flex flex-row items-center justify-between" >
            <div>Submitted(R)</div>
            <div className="underline cursor-pointer" onClick={() => props.redirectToProspect("isSubmitted(R)", "true")}>{props.dashboardDetails.completed}</div>
          </div>
        </div>
        <div className="relative justify-center corporateMember p-4 pl-24 rounded-lg">
          <div className="flex flex-row items-center justify-between title">
            <div className="icon">Corporate Member</div>
            <div className="number">{props.dashboardDetails.totalCorporateMember}</div>
          </div>
          <div className="flex flex-row items-center justify-between">
            <div className="font-bold">Total Active Members</div>
            <div className="font-bold">{props.dashboardDetails.totalActiveMembers}</div>
          </div>
          {/* <div className="flex flex-row items-center justify-between">
            <div className="ml-6">Expiry within 60 days</div>
            <div className="underline">{props.dashboardDetails.expiryWithin60}</div>
          </div>
          <div className="flex flex-row items-center justify-between cursor-pointer">
            <div className="ml-6">Expiry within 45 days</div>
            <div className="underline">{props.dashboardDetails.expiryWithin45}</div>
          </div>
          <div className="flex flex-row items-center justify-between cursor-pointer">
            <div className="ml-6">Expiry within 30 days</div>
            <div className="underline">{props.dashboardDetails.expiryWithin30}</div>
          </div> */}
          {/* <div className="flex flex-row items-center justify-between cursor-pointer">
            <div className="ml-6">Ongoing</div>
            <div className="underline">{props.dashboardDetails.totalActiveCorporateMembers - (props.dashboardDetails.expiryWithin30 +
              props.dashboardDetails.expiryWithin45 +
              props.dashboardDetails.expiryWithin60)}</div>
          </div> */}
          <div className="flex flex-row items-center justify-between">
            <div className="font-bold">Renewal</div>
            <div className="underline font-bold">{props.dashboardDetails.totalInactiveCorporateMembers}</div>
          </div>
          <div className="flex flex-row items-center justify-between">
            <div className="ml-6" onClick={props.redirecToCorporate} >Active member with expiry earlier than 1 Jan {new Date().toLocaleDateString('en-GB', { year: 'numeric' })}</div>
            <div className="">{props.dashboardDetails.expiryInSecondYear}</div>
          </div>
          <div className="flex flex-row items-center justify-between ">
            <div className="ml-6" >Renewal Members that will be prorated {new Date().toLocaleDateString('en-GB', { year: 'numeric' })} </div>
            <div className="underline cursor-pointer" onClick={() => props.redirecToCorporate("isProRated", "true")}>{props.dashboardDetails.renewalMemberProratedIn2025}</div>
          </div>
          <div className="flex flex-row items-center justify-between ">
            <div className="ml-6" onClick={props.redirecToCorporate} >Renewal Members aligned to 31st March {new Date().toLocaleDateString('en-GB', { year: 'numeric' })}  </div>
            <div className="underline cursor-pointer" onClick={() => props.redirecToCorporate("isForThirdYear", "true")}>{props.dashboardDetails.activeMember}</div>
          </div>
          <div className="flex flex-row items-center justify-between">
            <div className="ml-6" onClick={props.redirecToCorporate} >Active Member after 31 Dec {new Date().toLocaleDateString('en-GB', { year: 'numeric' })}</div>
            <div className="">{props.dashboardDetails.expiryInThirdYear}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default ProspectsCorporateMember;
